// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-frame[data-v-50348f76]{max-width:457px;border-radius:8px}", "",{"version":3,"sources":["webpack://src/components/widgets/LearnAboutMonetizationPrompt.vue"],"names":[],"mappings":"AAAA,8BAA8B,eAAe,CAAC,iBAAiB","sourcesContent":[".video-frame[data-v-50348f76]{max-width:457px;border-radius:8px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
